<template>
	<div class="page-rsvp" id="rsvp">
		<div class="container">
			<h2>RSVP</h2>
      <p>Please respond by the 1st of October by using the form below. <br>If you have any questions, please contact Tessa on <a href="tel:0450200089">0450200089</a></p>
      <!-- <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSca742JMU74zFVtF-5Im3baIo85Cpv-T4oBHgy9qnxzEeS5fQ/viewform?embedded=true" width="960" height="900" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe> -->
      <div id="container">
        <form v-wuform id="form1" name="form1" class="wufoo topLabel page" accept-charset="UTF-8" autocomplete="off" enctype="multipart/form-data" method="post" novalidate
              action="https://deansimcox.wufoo.com/forms/zwhrpte12ye1j1/#public">

        <header id="header" class="info">
        <h2>RSVP Form</h2>
        <div></div>
        </header><ul><li id="foli1" class="     ">
        <fieldset>
        <div>
        <input id="radioDefault_1" name="Field1" type="hidden" value="" />
        <span>
        <input id="Field1_0" name="Field1" type="radio" class="field radio" value="Wouldn&#039;t miss it for the world" tabindex="1" checked="checked"     required />
        <label class="choice" for="Field1_0" >
        <span class="choice__text notranslate">Wouldn't miss it for the world</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field1_1" name="Field1" type="radio" class="field radio" value="Will celebrate from afar" tabindex="2"     required />
        <label class="choice" for="Field1_1" >
        <span class="choice__text notranslate">Will celebrate from afar</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        </div>
        </fieldset>
        </li>
        <li id="foli2" class="notranslate      ">
        <label class="desc" id="title2" for="Field2">
        Email Address
        <span id="req_2" class="req">*</span>
        </label>
        <div>
        <input id="Field2" name="Field2" type="email" spellcheck="false" class="field text large" value="" maxlength="255" tabindex="3"       placeholder="" required />
        </div>
        </li>
        <li id="foli14"
        class="notranslate      "><label class="desc" id="title14" for="Field14">
        Name of Guests RSVP-ing
        <span id="req_14" class="req">*</span>
        </label>

        <div>
        <textarea id="Field14"
        name="Field14"
        class="field textarea small"
        spellcheck="true"
        rows="10" cols="50"

        tabindex="4"
        onkeyup=""
        placeholder=""
              required  ></textarea>

        </div>
        </li><li id="foli7" class="     ">
        <fieldset>
        <div>
        <input id="radioDefault_7" name="Field7" type="hidden" value="" />
        <span>
        <input id="Field7_0" name="Field7" type="radio" class="field radio" value="Glamping at Whispering Woods" tabindex="5" checked="checked"     required />
        <label class="choice" for="Field7_0" >
        <span class="choice__text notranslate">Glamping at Whispering Woods</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field7_1" name="Field7" type="radio" class="field radio" value="Karri Valley Resort" tabindex="6"     required />
        <label class="choice" for="Field7_1" >
        <span class="choice__text notranslate">Karri Valley Resort</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field7_2" name="Field7" type="radio" class="field radio" value="Other" tabindex="7" onmouseup="document.getElementById('Field7_other').focus();"     required />
        <label class="choice" for="Field7_2"  onmouseup="document.getElementById('Field7_other').focus();">
        <span class="choice__text notranslate">Other</span>
        <span class="choice__qty">
        </span>
        </label>
        <input id="Field7_other" name="Field7_other_Other" type="text" class="field text other" value="" onclick="document.getElementById('Field7_2').checked = 'checked';" tabindex="8" />
        </span>
        </div>
        </fieldset>
        </li><li id="foli8" class="     ">
        <fieldset>
        <div>
        <input id="radioDefault_8" name="Field8" type="hidden" value="" />
        <span>
        <input id="Field8_0" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Vegan heaven  (veg)&lt;/strong&gt; - Tomato base, spinach, capsicum, mushrooms, artichoke, pumpkin, olives, pine nuts, caramelized onion &amp; herbs." tabindex="9" checked="checked"     required />
        <label class="choice" for="Field8_0" >
        <span class="choice__text notranslate"><strong>Vegan heaven  (veg)</strong> - Tomato base, spinach, capsicum, mushrooms, artichoke, pumpkin, olives, pine nuts, caramelized onion & herbs.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_1" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Grommie&#039;s choice (veg)&lt;/strong&gt; - Tomato base, mozza cheese and optional herbs" tabindex="10"     required />
        <label class="choice" for="Field8_1" >
        <span class="choice__text notranslate"><strong>Grommie's choice (veg)</strong> - Tomato base, mozza cheese and optional herbs</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_2" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Flower power (veg)&lt;/strong&gt; - A beautiful satay base, smoked cheese, local mushrooms, artichoke, kalamata olives &amp; red onion." tabindex="11"     required />
        <label class="choice" for="Field8_2" >
        <span class="choice__text notranslate"><strong>Flower power (veg)</strong> - A beautiful satay base, smoked cheese, local mushrooms, artichoke, kalamata olives & red onion.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_3" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Margherita (veg)&lt;/strong&gt; - Tomato base, mozzarella cheese, bocconcini balls, basil leaves, cherry tomato, topped with basil." tabindex="12"     required />
        <label class="choice" for="Field8_3" >
        <span class="choice__text notranslate"><strong>Margherita (veg)</strong> - Tomato base, mozzarella cheese, bocconcini balls, basil leaves, cherry tomato, topped with basil.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_4" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Longboard&lt;/strong&gt; - Tomato base, mozza, shaved leg ham, fresh rosemary sprigs, pineapple chunks reg." tabindex="13"     required />
        <label class="choice" for="Field8_4" >
        <span class="choice__text notranslate"><strong>Longboard</strong> - Tomato base, mozza, shaved leg ham, fresh rosemary sprigs, pineapple chunks reg.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_5" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Woodstock&lt;/strong&gt; - Smokey bbq base, mozza &amp; pepperoni." tabindex="14"     required />
        <label class="choice" for="Field8_5" >
        <span class="choice__text notranslate"><strong>Woodstock</strong> - Smokey bbq base, mozza & pepperoni.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_6" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Jimi hendrix&lt;/strong&gt; - Tomato base, local mozzarella cheese, bbq glazed chicken &amp; fresh herbs." tabindex="15"     required />
        <label class="choice" for="Field8_6" >
        <span class="choice__text notranslate"><strong>Jimi hendrix</strong> - Tomato base, local mozzarella cheese, bbq glazed chicken & fresh herbs.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_7" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Budda (veg)&lt;/strong&gt; - Tomato base, smoked cheese, local mushrooms, artichoke, kalamata olives &amp; red onion." tabindex="16"     required />
        <label class="choice" for="Field8_7" >
        <span class="choice__text notranslate"><strong>Budda (veg)</strong> - Tomato base, smoked cheese, local mushrooms, artichoke, kalamata olives & red onion.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_8" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Retro piggy&lt;/strong&gt; - Tomato base, south west mozza, ham, bacon, chorizo, parmesan, chili flakes and drizzled eagle bay honey." tabindex="17"     required />
        <label class="choice" for="Field8_8" >
        <span class="choice__text notranslate"><strong>Retro piggy</strong> - Tomato base, south west mozza, ham, bacon, chorizo, parmesan, chili flakes and drizzled eagle bay honey.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_9" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Pumpkin head (veg)&lt;/strong&gt; - Tomato base, mozza, pine nuts, feta, honey, pumpkin &amp; caramelised red onion &amp; garnished with rocket." tabindex="18"     required />
        <label class="choice" for="Field8_9" >
        <span class="choice__text notranslate"><strong>Pumpkin head (veg)</strong> - Tomato base, mozza, pine nuts, feta, honey, pumpkin & caramelised red onion & garnished with rocket.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_10" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;Who pears wins&lt;/strong&gt; - Tomato base, mozzarella, south west prosciutto, thinly sliced fresh nashi pear, brown sugar and rocket." tabindex="19"     required />
        <label class="choice" for="Field8_10" >
        <span class="choice__text notranslate"><strong>Who pears wins</strong> - Tomato base, mozzarella, south west prosciutto, thinly sliced fresh nashi pear, brown sugar and rocket.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        <span>
        <input id="Field8_11" name="Field8" type="radio" class="field radio" value="&lt;strong&gt;The old country&lt;/strong&gt; - Tomato base, mozza, anchovies, smoked muchrooms, italian sausage, fire roasted capsicum, kalamata olives." tabindex="20"     required />
        <label class="choice" for="Field8_11" >
        <span class="choice__text notranslate"><strong>The old country</strong> - Tomato base, mozza, anchovies, smoked muchrooms, italian sausage, fire roasted capsicum, kalamata olives.</span>
        <span class="choice__qty">
        </span>
        </label>
        </span>
        </div>
        </fieldset>
        </li>
        <li id="foli13"
        class="notranslate      "><label class="desc" id="title13" for="Field13">
        Do you have any dietary requirements?
        </label>

        <div>
        <textarea id="Field13"
        name="Field13"
        class="field textarea small"
        spellcheck="true"
        rows="10" cols="50"

        tabindex="21"
        onkeyup=""
        placeholder=""
              ></textarea>

        </div>
        </li>
        <li id="foli12"
        class="notranslate      "><label class="desc" id="title12" for="Field12">
        Beer and wine preferences?
        </label>

        <div>
        <textarea id="Field12"
        name="Field12"
        class="field textarea small"
        spellcheck="true"
        rows="10" cols="50"

        tabindex="22"
        onkeyup=""
        placeholder=""
              ></textarea>

        </div>
        </li>
        <li id="foli15"
        class="notranslate      "><label class="desc" id="title15" for="Field15">
        Anything else you want to tell us?
        </label>

        <div>
        <textarea id="Field15"
        name="Field15"
        class="field textarea medium"
        spellcheck="true"
        rows="10" cols="50"

        tabindex="23"
        onkeyup=""
        placeholder=""
              ></textarea>

        </div>
        </li> <li class="buttons ">
        <div>

                            <input id="saveForm" name="saveForm" class="btTxt submit"
            type="submit" value="Submit"
        /><!--<a href="https://master.wufoo.com/forms/m7p0x3/def/field1=deansimcox.wufoo.com/forms/rsvp-form/"
        target="_blank"
        style="font-size:85% !important;visibility:visible !important;display:inline !important;
        background:none !important;border:none !important;color:blue !important;
        text-indent:0 !important;text-decoration:underline !important;position:static !important;
        margin:0 !important;padding:0 !important;overflow:none !important
        width:auto !important;height:auto !important;">Report Abuse</a>-->
        </div>
        </li>

        <li class="hide">
        <label for="comment">Do Not Fill This Out</label>
        <textarea name="comment" id="comment" rows="1" cols="1"></textarea>
        <input type="hidden" id="idstamp" name="idstamp" value="7kKhPh0R6oI8N92r78KICv5q0wYCzPvWyrb6u4Ak594=" />
        </li>
        </ul>
        </form>
      </div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'RsvpPage',
};
</script>

<style scoped>
#container {
  font-size: 13px;
  text-align: left;
  background: #fff;
  border: 1px solid #ccc;
  -webkit-box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px;
  -moz-box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px;
  -o-box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px
}
#container {
  margin: 0 auto 10px auto;
  width: 640px
}
form.wufoo {
  margin: 20px 14px 0 14px;
  padding: 0 0 20px 0;
  position: relative
}
#logo {
  margin: 0;
  padding: 0;
  min-height: 0;
  background-color: #dedede;
  text-indent: -9000px;
  text-decoration: none
}
#logo a {
  min-height: 40px;
  height: 40px;
  display: block;
  /* background: url('../assets/wflogo.png') no-repeat left top; */
  overflow: hidden
}
img,
a img {
  border: none;
  -ms-interpolation-mode: bicubic
}
.hide,
.cloak div,
.cloak span,
.likert.cloak tbody,
.likert.cloak thead {
  display: none !important
}
.likert.cloak table {
  border: none
}

.info {
  display: inline-block;
  clear: both;
  margin: 0 0 5px 0;
  padding: 0 1% 1.1em 1%;
  border-bottom: 1px dotted #ccc
}
.info[class] {
  display: block
}
.hideHeader .info,
#payment.hideHeader li.first {
  display: none
}
.info h2 {
  font-weight: normal;
  font-size: 160%;
  margin: 0 0 5px 0;
  clear: left
}
.info div {
  font-size: 95%;
  line-height: 135%;
  color: #555
}
form ul {
  margin: 0;
  padding: 0;
  list-style-type: none
}
form li {
  margin: 0;
  padding: 6px 1% 9px 1%;
  clear: both;
  background-color: transparent;
  position: relative;
  -webkit-transition: background-color 350ms ease-out;
  -moz-transition: background-color 350ms ease-out;
  -o-transition: background-color 350ms ease-out;
  transition: background-color 350ms ease-out
}
form ul:after,
form li:after,
form li div:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden
}
* html form li {
  height: 1%;
  margin-bottom: -3px
}
*+html form li {
  height: 1%;
  margin-bottom: -3px
}
* html form li div {
  display: inline-block
}
*+html form ul,
*+html form li div {
  display: inline-block
}
form li div {
  margin: 0;
  padding: 0;
  color: #444
}
form li span {
  margin: 0 .3em 0 0;
  padding: 0;
  float: none;
  color: #444
}
form li div span {
  margin: 10px 0;
  display: block;
  width: 100%;
  float: none
}
li.twoColumns div span {
  width: 48%;
  margin: 0 5px 0 0
}
li.threeColumns div span {
  width: 30%;
  margin: 0 5px 0 0
}
li.notStacked div span {
  width: auto;
  margin: 0 7px 0 0
}
form li.complex {
  padding-bottom: 0
}
form li.complex div span {
  width: auto;
  margin: 0 .3em 0 0;
  padding-bottom: 12px
}
form li.complex div span.full {
  margin: 0
}
form li.complex div span.left,
form li.complex div span.right {
  margin: 0;
  width: 48%
}
form li.complex div span.full input,
form li.complex div span.full select,
form li.complex div span.left input,
form li.complex div span.right input,
form li.complex div span.left select,
form li.complex div span.right select {
  width: 100%
}
.left {
  float: left
}
.right {
  float: right
}
.clear {
  clear: both !important
}
label span,
.section span,
p span,
.likert span {
  display: inline !important;
  float: none !important
}
form li div label,
form li span label {
  margin: 0;
  padding-top: 3px;
  clear: both;
  font-size: 85%;
  line-height: 160%;
  color: #444;
  display: block
}
fieldset {
  display: block;
  border: none;
  margin: 0;
  padding: 0
}
label.desc,
legend.desc {
  font-size: 95%;
  font-weight: bold;
  color: #222;
  line-height: 150%;
  margin: 0;
  padding: 0 0 3px 0;
  border: none;
  display: block;
  white-space: normal;
  width: 100%
}
label.choice {
  display: block;
  cursor: pointer;
  font-size: 100%;
  line-height: 150%;
  margin: 0 0 0 23px;
  padding: 0 0 5px 0;
  color: #222;
  width: 88%
}
#public input[disabled]+label.choice {
  cursor: default
}
#public input[disabled]+label.choice span {
  color: #777
}
.safari label.choice {
  margin-top: -16px
}
form.rightLabel .desc {
  padding-top: 2px
}
span.symbol {
  font-size: 120%;
  line-height: 135%
}
form li .datepicker {
  float: left;
  margin: .19em 5px 0 0;
  padding: 0;
  width: 16px;
  height: 16px;
  cursor: pointer !important
}
li .choice__qty {
  font-size: 0.9em;
  font-style: italic;
  color: #777
}
li.hideQty .choice__qty,
li.hideQuantity .choice__qty {
  display: none !important
}
form span.req {
  display: inline;
  float: none;
  color: red !important;
  font-weight: bold;
  margin: 0;
  padding: 0
}
form li div label var {
  font-weight: bold;
  font-style: normal
}
form li div label .currently {
  display: none
}
input.text,
input.search,
input.file,
textarea.textarea,
select.select {
  font-family: "Lucida Grande", Tahoma, Arial, sans-serif;
  font-size: 100%;
  color: #333;
  margin: 0;
  padding: 2px 0
}
input.text,
input.search,
textarea.textarea {
  border-top: 1px solid #7c7c7c;
  border-left: 1px solid #c3c3c3;
  border-right: 1px solid #c3c3c3;
  border-bottom: 1px solid #ddd;
  /* background: #fff url('../assets/fieldbg.gif') repeat-x top */
}
input.nospin::-webkit-inner-spin-button,
input.nospin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0
}
select.select {
  padding: 1px 0 0 0
}
input.search {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  padding-left: 6px
}
input.checkbox,
input.radio {
  display: block;
  margin: 4px 0 0 0;
  padding: 0;
  width: 13px;
  height: 13px
}
input.other {
  margin: 0 0 8px 25px
}
.safari select.select {
  font-size: 120% !important;
  margin: 0 0 1px 0
}
* html select.select {
  margin: 1px 0
}
*+html select.select {
  margin: 1px 0
}
.center,
form li span.center input.text,
form li span.center label,
form li.name span label,
form li.date input.text,
form li.date span label,
form li.phone input.text,
form li.phone span label,
form li.time input.text,
form li.time span label {
  text-align: center
}
form li.time select.select {
  margin-left: 5px
}
form li.price .right {
  text-align: right
}
.third {
  width: 32% !important
}
.half {
  width: 48% !important
}
.full {
  width: 100% !important
}
input.small,
select.small {
  width: 25%
}
input.medium,
select.medium {
  width: 50%
}
input.large,
select.large {
  width: 100%
}
textarea.textarea {
  width: 293px;
  min-width: 100%;
  max-width: 100%
}
textarea.small {
  height: 5.5em
}
textarea.medium {
  height: 10em
}
textarea.large {
  height: 20em
}
li.file a {
  color: #222;
  text-decoration: none
}
li.file span {
  display: inline;
  float: none
}
li.file img {
  display: block;
  float: left;
  margin: 0 0 0 -10px;
  padding: 5px 5px 7px 5px
}
li.file .file-size,
li.file .file-type {
  color: #666;
  font-size: 85%;
  text-transform: uppercase
}
li.file .file-name {
  display: block;
  padding: 14px 0 0 0;
  color: blue;
  text-decoration: underline
}
li.file .file-delete {
  color: red !important;
  font-size: 85%;
  text-decoration: underline
}
li.file a:hover .file-name {
  color: green !important
}
li.file a:hover .file-name {
  color: green !important
}
form li.likert {
  margin: 0;
  padding: 6px 1% 5px 1%;
  width: auto !important;
  clear: both !important;
  float: none !important
}
.likert table {
  margin: 0 0 .9em 0;
  background: #fff;
  width: 100%;
  border: 1px solid #dedede;
  border-bottom: none
}
.likert caption {
  text-align: left;
  color: #222;
  font-size: 95%;
  line-height: 135%;
  padding: 5px 0 .5em 0
}
.likert input {
  padding: 0;
  margin: 2px 0
}
.likert tbody td label {
  font-size: 85%;
  display: block;
  color: #565656
}
.likert thead td,
.likert thead th {
  background-color: #e6e6e6
}
.likert td {
  border-left: 1px solid #ccc;
  text-align: center;
  padding: 4px 6px
}
.likert thead td {
  font-size: 85%;
  padding: 10px 6px
}
.likert th,
.likert td {
  border-bottom: 1px solid #dedede
}
.likert tbody th {
  padding: 8px 8px;
  text-align: left
}
.likert tbody th label {
  color: #222;
  font-size: 95%;
  font-weight: bold
}
.likert tbody tr.alt td,
.likert tbody tr.alt th {
  background-color: #f5f5f5
}
.likert tbody tr:hover td,
.likert tbody tr:hover th {
  background-color: #FFFFCF
}
.col1 td {
  width: 30%
}
.col2 td {
  width: 25%
}
.col3 td {
  width: 18%
}
.col4 td {
  width: 14.5%
}
.col5 td {
  width: 12%
}
.col6 td,
.col7 td {
  width: 10%
}
.col8 td,
.col9 td,
.col10 td {
  width: 6.5%
}
.col11 {
  width: 6%
}
.hideNumbers tbody td label {
  display: none
}
form li.buttons {
  width: auto !important;
  position: relative;
  clear: both;
  padding: 10px 1% 10px 1%
}
form li.buttons input {
  font-size: 100%;
  margin-right: 5px
}
input.btTxt {
  padding: 0 7px;
  width: auto;
  overflow: visible
}
.safari input.btTxt {
  font-size: 120%
}
.buttons .marker {
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px 10px 0 0;
  color: #000;
  width: auto
}
button.link {
  display: inline-block;
  border: none;
  background: none;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font-size: 100%
}
button.link:hover {
  color: green
}
.leftLabel li,
.rightLabel li {
  width: 74% !important;
  padding-top: 9px
}
.leftLabel .desc,
.rightLabel .desc {
  float: left;
  width: 31%;
  margin: 0 15px 0 0
}
.rightLabel .desc {
  text-align: right
}
.leftLabel li div,
.rightLabel li div {
  float: left;
  width: 65%
}
* html .leftLabel li fieldset div,
* html .rightLabel li fieldset div {
  float: right
}
*+html .leftLabel li fieldset div,
*+html .rightLabel li fieldset div {
  float: right
}
.leftLabel .buttons,
.rightLabel .buttons {
  padding-left: 23%
}
.leftLabel .buttons div,
.rightLabel .buttons div {
  float: none;
  margin: 0 0 0 20px
}
.leftLabel p.instruct,
.rightLabel p.instruct {
  width: 28%;
  margin-left: 5px
}
.leftLabel .altInstruct .instruct,
.rightLabel .altInstruct .instruct {
  margin-left: 31% !important;
  padding-left: 15px;
  width: 65%
}
.noI form li,
.altInstruct form li {
  width: auto !important
}
.noI .leftLabel .buttons,
.noI .rightLabel .buttons {
  padding-left: 31%
}
.noI .leftLabel .buttons div,
.noI .rightLabel .buttons div {
  margin: 0 0 0 17px
}
form li.leftHalf,
form li.rightHalf {
  width: 47% !important
}
form li.leftThird,
form li.middleThird,
form li.rightThird {
  width: 30% !important
}
form li.leftFourth,
form li.middleFourth,
form li.rightFourth {
  width: 23% !important;
  _width: 22% !important
}
form li.leftFifth,
form li.middleFifth,
form li.rightFifth {
  width: 18% !important;
  _width: 17% !important
}
form li.middleThird {
  clear: none !important;
  float: left;
  margin-left: 2% !important
}
form li.leftFourth,
form li.middleFourth,
form li.leftFifth,
form li.middleFifth {
  clear: none !important;
  float: left
}
form li.rightHalf,
form li.rightThird,
form li.rightFourth,
form li.rightFifth {
  clear: none !important;
  float: right
}
li.leftHalf .small,
li.rightHalf .small,
li.leftHalf .medium,
li.rightHalf .medium,
li.leftThird .small,
li.middleThird .small,
li.rightThird .small,
li.leftThird .medium,
li.middleThird .medium,
li.rightThird .medium,
li.leftFourth .medium,
li.middleFourth .medium,
li.rightFourth .medium,
li.leftFourth .small,
li.middleFourth .small,
li.rightFourth .small,
li.leftFifth .medium,
li.middleFifth .medium,
li.rightFifth .medium,
li.leftFifth .small,
li.middleFifth .small,
li.rightFifth .small {
  width: 100% !important
}
form li.leftHalf,
form li.leftThird,
form li.leftFourth,
form li.leftFifth {
  clear: left !important;
  float: left
}
* html form li.middleFourth {
  margin-left: 1% !important
}
* html form li.middleFifth {
  margin-left: 1% !important
}
form li.focused {
  background-color: #fff7c0
}
form .instruct {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 45%;
  margin: 0 0 0 8px;
  padding: 8px 10px 10px 10px;
  border: 1px solid #e6e6e6;
  background: #f5f5f5;
  visibility: hidden;
  opacity: 0;
  font-size: 105%;
  -webkit-transition: opacity 350ms ease-out;
  -moz-transition: opacity 350ms ease-out;
  -o-transition: opacity 350ms ease-out;
  transition: opacity 350ms ease-out
}
form .instruct small {
  line-height: 120%;
  font-size: 80%;
  color: #444
}
form li.focused .instruct,
form li:hover .instruct {
  left: 100%;
  visibility: visible;
  opacity: 1
}
.altInstruct .instruct,
li.leftHalf .instruct,
li.rightHalf .instruct,
li.leftThird .instruct,
li.middleThird .instruct,
li.rightThird .instruct,
li.leftFourth .instruct,
li.middleFourth .instruct,
li.rightFourth .instruct,
li.leftFifth .instruct,
li.middleFifth .instruct,
li.rightFifth .instruct,
.iphone .instruct {
  visibility: visible;
  position: static;
  margin: 0;
  padding: 6px 0 0 0;
  width: 100%;
  clear: left;
  background: none !important;
  border: none !important;
  font-style: italic;
  opacity: 1
}
.altInstruct p.complex,
li.leftHalf p.complex,
li.rightHalf p.complex,
li.leftThird p.complex,
li.middleThird p.complex,
li.rightThird p.complex,
.iphone p.complex {
  padding: 0 0 9px 0
}
.hideSeconds .seconds,
.hideAMPM .ampm,
.hideAddr2 .addr2,
.hideSecondary #previousPageButton,
.hideCents .radix,
.hideCents .cents,
.hideState .state {
  display: none
}
form li.section {
  clear: both;
  margin: 0;
  padding: 7px 0 0 0;
  width: auto !important;
  position: static
}
form li.section h3 {
  font-weight: normal;
  font-size: 110%;
  line-height: 135%;
  margin: 0 0 3px 0;
  width: auto;
  padding: 12px 1% 0 1%;
  border-top: 1px dotted #ccc
}
form li.first {
  padding: 0
}
form li.first h3 {
  padding: 8px 1% 0 1%;
  border-top: none !important
}
form li.section div {
  display: block;
  width: auto;
  float: none;
  font-size: 85%;
  line-height: 160%;
  margin: 0 0 1em 0;
  padding: 0 1% 0 1%
}
form li.section.scrollText {
  border: 1px solid #dedede;
  height: 150px;
  overflow: auto;
  margin-bottom: 10px;
  padding: 10px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.15) 0 0 3px;
  -moz-box-shadow: rgba(0, 0, 0, 0.15) 0 0 3px;
  -o-box-shadow: rgba(0, 0, 0, 0.15) 0 0 3px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 0 3px
}
form li.section.scrollText h3 {
  border: none;
  padding-top: 8px
}
form li.captcha {
  width: auto !important;
  clear: both;
  border-top: 1px dotted #ccc;
  margin-top: 5px;
  padding: 1.1em 1% 9px 1%;
  width: auto !important;
  position: static
}
form li.captcha label.desc {
  width: auto !important;
  margin-bottom: 4px;
  float: none
}
*+html #recaptcha_area,
*+html #recaptcha_table {
  min-width: 450px !important
}
* html #recaptcha_area,
* html #recaptcha_table {
  width: 450px !important
}
#recaptcha_widget_div table {
  background: #fff
}
form li.captcha .noscript iframe {
  border: none;
  overflow: hidden;
  margin: 0;
  padding: 0
}
form li.captcha .noscript label.desc {
  display: block !important
}
form li.captcha .noscript textarea {
  margin-left: 12px
}
iframe[src="about:blank"] {
  display: none
}
form li.paging-context {
  clear: both;
  border-bottom: 1px dotted #ccc;
  margin: 0 0 7px 0;
  padding: 5px 1% 10px 1%;
  width: auto !important;
  position: static
}
.paging-context table {
  width: 100%
}
.pgStyle1 td {
  text-align: left;
  vertical-align: middle
}
.pgStyle1 td.c {
  width: 22px
}
.pgStyle1 td.t {
  padding: 0 1%
}
.pgStyle1 var {
  display: block;
  float: left;
  background: none;
  border: 1px solid #CCC;
  color: #000;
  width: 20px;
  height: 20px;
  line-height: 19px;
  text-align: center;
  font-size: 85%;
  font-style: normal;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.15) 0 1px 2px;
  -moz-box-shadow: rgba(0, 0, 0, 0.15) 0 1px 2px;
  -o-box-shadow: rgba(0, 0, 0, 0.15) 0 1px 2px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 1px 2px
}
.pgStyle1 .done var {
  background: #ccc
}
.pgStyle1 .selected var {
  background: #FFF7C0;
  color: #000;
  border: 1px solid #e6dead;
  font-weight: bold
}
.pgStyle1 b {
  font-size: 85%;
  font-weight: normal;
  color: #000
}
.pgStyle1 .selected b {
  font-weight: bold
}
.circle6 td,
.circle7 td {
  vertical-align: top;
  text-align: center
}
.nopagelabel td.t {
  display: none
}
.nopagelabel .pgStyle1 var,
.circle6 var,
.circle7 var {
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 90%;
  margin: 0 auto 7px auto;
  float: none;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px
}
.nopagelabel .pgStyle1 var {
  margin-bottom: 0
}
.circle6 b,
.circle7 b {
  padding: 0
}
.circle2 td {
  width: 50%
}
.circle3 td {
  width: 33%
}
.circle4 td {
  width: 25%
}
.circle5 td {
  width: 20%
}
.circle6 td {
  width: 16.6%
}
.circle7 td {
  width: 14.2%
}
.pgStyle2 td {
  vertical-align: middle;
  height: 25px;
  padding: 2px;
  border: 1px solid #CCC;
  position: relative;
  -webkit-border-radius: 14px;
  -moz-border-radius: 14px;
  border-radius: 14px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px;
  -moz-box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px;
  -o-box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px
}
.pgStyle2 var {
  display: block;
  height: 26px;
  float: left;
  background: #FFF7C0;
  color: #000;
  font-style: normal;
  text-align: right;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.15) 1px 0 0;
  -moz-box-shadow: rgba(0, 0, 0, 0.15) 1px 0 0;
  -o-box-shadow: rgba(0, 0, 0, 0.15) 1px 0 0;
  box-shadow: rgba(0, 0, 0, 0.15) 1px 0 0
}
.pgStyle2 var b {
  display: block;
  float: right;
  font-size: 100%;
  padding: 3px 10px 3px 3px;
  line-height: 19px
}
.pgStyle2 em {
  font-size: 85%;
  font-style: normal;
  display: inline-block;
  margin: 0 0 0 9px;
  padding: 4px 0;
  line-height: 18px
}
.pgStyle2 var em {
  padding: 4px 5px 3px 0
}
.page1 .pgStyle2 var {
  padding-left: 7px;
  text-align: left;
  background: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none
}
.page1 .pgStyle2 b {
  float: none;
  padding-right: 0
}
.hideMarkers .marker,
.nopagelabel .pgStyle1 b,
.nopagelabel .pgStyle2 em {
  display: none !important
}
#errorLi,
.error-container {
  width: 99%;
  margin: 15px auto 15px auto;
  background: #fff !important;
  border: 1px solid red;
  text-align: center;
  padding: 1em 0 1em 0;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px
}
#errorMsgLbl {
  margin: 0 0 5px 0;
  padding: 0;
  font-size: 125%;
  color: #DF0000 !important
}
#errorMsg {
  margin: 0 0 2px 0;
  color: #000 !important;
  font-size: 100%
}
#errorMsg b {
  padding: 2px 8px;
  background-color: #FFDFDF !important;
  color: red !important;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px
}
form li.error {
  display: block !important;
  background-color: #FFDFDF !important;
  margin-bottom: 3px !important
}
form li label.error,
form li input.error {
  color: #DF0000 !important;
  font-weight: bold !important
}
form li input.error {
  background: #fff !important;
  border: 2px solid #DF0000 !important
}
form li.error label,
form li.error span.symbol {
  color: #000 !important
}
form li.error .desc {
  color: #DF0000 !important
}
form p.error {
  display: none;
  margin: 0 !important;
  padding: 7px 0 0 0 !important;
  line-height: 10px !important;
  font-weight: bold;
  font-size: 11px;
  color: #DF0000 !important;
  clear: both
}
form li.error p.error {
  display: block
}
form li.complex p.error {
  padding: 0 0 9px 0 !important
}
.rtl h1,
.rtl form * {
  direction: rtl;
  text-align: right
}
.rtl li span {
  float: right
}
.rtl .right {
  float: left
}
.rtl #logo a {
  background-position: right top
}
.rtl label.choice {
  margin: 0 23px 0 0
}
.rtl .leftLabel .desc,
.rtl .rightLabel .desc {
  float: right;
  margin: 0 0 0 15px
}
.rtl .leftLabel li div,
.rtl .rightLabel li div {
  float: right
}
.rtl .leftLabel .desc {
  text-align: left
}
.rtl li.focused .instruct,
.rtl li:hover .instruct {
  left: auto;
  right: 100%
}
.rtl .leftLabel p.instruct,
.rtl .rightLabel p.instruct {
  margin-right: 5px
}
.rtl .leftLabel .altInstruct .instruct,
.rtl .rightLabel .altInstruct .instruct {
  margin-right: 31% !important;
  padding-right: 15px
}
.rtl .leftLabel .buttons,
.rtl .rightLabel .buttons {
  padding-right: 23%
}
.rtl .leftLabel .buttons div,
.rtl .rightLabel .buttons div {
  float: none;
  margin: 0 20px 0 0
}
.noI .rtl .leftLabel .buttons,
.noI .rtl .rightLabel .buttons {
  padding-right: 31%
}
.noI .rtl .leftLabel .buttons div,
.noI .rtl .rightLabel .buttons div {
  margin: 0 17px 0 0
}
.rtl .likert td label {
  text-align: center
}
.rtl .likert caption,
.rtl .likert tbody th {
  text-align: right
}
.rtl .likert td {
  text-align: center;
  border-left: none;
  border-right: 1px solid #ccc
}
.rtl .pgStyle1 var {
  text-align: center
}
.rtl .pgStyle1 td {
  text-align: right
}
.rtl .pgStyle2 var {
  float: right
}
.rtl .pgStyle2 var b {
  float: left;
  padding: 3px 3px 3px 10px
}
.rtl .pgStyle2 em {
  margin: 0 9px 0 0
}
.rtl .pgStyle2 var em {
  padding: 4px 0 3px 5px
}
.rtl .page1 .pgStyle2 var {
  padding-right: 7px
}
.rtl .page1 .pgStyle2 b {
  padding-left: 0
}
.rtl .buttons .marker {
  right: auto;
  left: 0;
  padding: 15px 0 0 10px
}
.rtl #errorLi * {
  text-align: center
}
.rating span {
  cursor: pointer
}
.rating span:focus {
  outline: 0
}
.rating span,
.rating:hover span:hover ~ span {
  font-size: 20px;
  line-height: 1em;
  width: .9em;
  height: 1em;
  padding-right: .1em;
  color: #c7c7c7;
  text-shadow: 0 0 1px #444
}
.rating .clicked {
  color: #FFD954
}
.rating>span:hover,
.rating .clicked:hover,
.rating:hover span {
  color: #ffe487;
  text-shadow: 0 0 1px #ff0000;
  cursor: pointer
}
.rating:hover span {
  _color: #c7c7c7
}

@media print {
  .rating span {
    color: #c7c7c7
  }
}
/* ----- Logo ----- */

#logo a {
  /* background-image: url('../assets/wflogo.png'); */
  min-height: 0;
  height: 40px;
}

html {
  background-image: none;
  background-color: #EEEEEE;
}
#logo {
  background-image: none;
  background-color: #DEDEDE;
}
#container,
html.embed {
  background-color: #FFFFFF;
}
.safari .wufoo input.file {
  background: none;
  border: none;
}
.wufoo li.focused {
  background-color: #FFF7C0;
}
.wufoo .instruct {
  background-color: #F5F5F5;
}
/* ----- Borders ----- */

#container {
  border: 1px solid #CCCCCC;
}
.wufoo .info,
.wufoo .paging-context {
  border-bottom: 1px dotted #CCCCCC;
}
.wufoo .section h3,
.wufoo .captcha,
#payment .paging-context {
  border-top: 1px dotted #CCCCCC;
}
.wufoo input.text,
.wufoo textarea.textarea {} .wufoo .instruct {
  border: 1px solid #E6E6E6;
}
.fixed .info {
  border-bottom: none;
}
.wufoo li.section.scrollText {
  border-color: #dedede;
}
/* ----- Typography ----- */

.wufoo .info h2 {
  font-size: 160%;
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  color: #000000;
}
.wufoo .info div {
  font-size: 95%;
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  color: #444444;
}
.wufoo .section h3 {
  font-size: 110%;
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  color: #000000;
}
.wufoo .section div {
  font-size: 85%;
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  color: #444444;
}
.wufoo label.desc,
.wufoo legend.desc {
  font-size: 95%;
  font-family: inherit;
  font-style: normal;
  font-weight: bold;
  color: #444444;
}
.wufoo label.choice {
  font-size: 100%;
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  color: #444444;
}
.wufoo input.text,
.wufoo textarea.textarea,
.wufoo input.file,
.wufoo select.select {
  font-style: normal;
  font-weight: normal;
  color: #333333;
  font-size: 100%;
}
.wufoo input.text,
.wufoo textarea.textarea,
.wufoo input.file {
  font-family: inherit;
}
.wufoo li div,
.wufoo li span,
.wufoo li div label,
.wufoo li span label {
  font-family: inherit;
  color: #444444;
}
.safari .wufoo input.file {
  /* Webkit */

  font-size: 100%;
  font-family: inherit;
  color: #444444;
}
.wufoo .instruct small {
  font-size: 80%;
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  color: #444444;
}
.altInstruct small,
li.leftHalf small,
li.rightHalf small,
li.leftThird small,
li.middleThird small,
li.rightThird small,
.iphone small {
  color: #444444 !important;
}
/* ----- Button Styles ----- */

.wufoo input.btTxt {}
/* ----- Highlight Styles ----- */

.wufoo li.focused label.desc,
.wufoo li.focused legend.desc,
.wufoo li.focused div,
.wufoo li.focused span,
.wufoo li.focused div label,
.wufoo li.focused span label,
.safari .wufoo li.focused input.file {
  color: #000000;
}
/* ----- Confirmation ----- */

.confirm h2 {
  font-family: inherit;
  color: #444444;
}
a.powertiny b,
a.powertiny em {
  color: #1a1a1a !important;
}
.embed a.powertiny b,
.embed a.powertiny em {
  color: #1a1a1a !important;
}
/* ----- Pagination ----- */

.pgStyle1 var,
.pgStyle2 var,
.pgStyle2 em,
.page1 .pgStyle2 var,
.pgStyle1 b,
.wufoo .buttons .marker {
  font-family: inherit;
  color: #444444;
}
.pgStyle1 var,
.pgStyle2 td {
  border: 1px solid #cccccc;
}
.pgStyle1 .done var {
  background: #cccccc;
}
.pgStyle1 .selected var,
.pgStyle2 var,
.pgStyle2 var em {
  background: #FFF7C0;
  color: #000000;
}
.pgStyle1 .selected var {
  border: 1px solid #e6dead;
}
/* Likert Backgrounds */

.likert table {
  background-color: #FFFFFF;
}
.likert thead td,
.likert thead th {
  background-color: #e6e6e6;
}
.likert tbody tr.alt td,
.likert tbody tr.alt th {
  background-color: #f5f5f5;
}
/* Likert Borders */

.likert table,
.likert th,
.likert td {
  border-color: #dedede;
}
.likert td {
  border-left: 1px solid #cccccc;
}
/* Likert Typography */

.likert caption,
.likert thead td,
.likert tbody th label {
  color: #444444;
  font-family: inherit;
}
.likert tbody td label {
  color: #575757;
  font-family: inherit;
}
.likert caption,
.likert tbody th label {
  font-size: 95%;
}
/* Likert Hover */

.likert tbody tr:hover td,
.likert tbody tr:hover th,
.likert tbody tr:hover label {
  background-color: #FFF7C0;
  color: #000000;
}
.likert tbody tr:hover td {
  border-left: 1px solid #ccc69a;
}
/* ----- Running Total ----- */

.wufoo #lola {
  background: #e6e6e6;
}
.wufoo #lola tbody td {
  border-bottom: 1px solid #cccccc;
}
.wufoo #lola {
  font-family: inherit;
  color: #444444;
}
.wufoo #lola tfoot th {
  color: #696969;
}
/* ----- Report Styles ----- */

.wufoo .wfo_graph h3 {
  font-size: 95%;
  font-family: inherit;
  color: #444444;
}
.wfo_txt,
.wfo_graph h4 {
  color: #444444;
}
.wufoo .footer h4 {
  color: #000000;
}
.wufoo .footer span {
  color: #444444;
}
/* ----- Number Widget ----- */

.wfo_number {
  background-color: #f5f5f5;
  border-color: #dedede;
}
.wfo_number strong,
.wfo_number em {
  color: #000000;
}
/* ----- Chart Widget Border and Background Colors ----- */

#widget,
#widget body {
  background: #FFFFFF;
}
.fcNav a.show {
  background-color: #FFFFFF;
  border-color: #cccccc;
}
.fc table {
  border-left: 1px solid #dedede;
}
.fc thead th,
.fc .more th {
  background-color: #dedede !important;
  border-right: 1px solid #cccccc !important;
}
.fc tbody td,
.fc tbody th,
.fc tfoot th,
.fc tfoot td {
  background-color: #FFFFFF;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #dedede;
}
.fc tbody tr.alt td,
.fc tbody tr.alt th,
.fc tbody td.alt {
  background-color: #f5f5f5;
}
/* ----- Chart Widget Typography Colors ----- */

.fc caption,
.fcNav,
.fcNav a {
  color: #444444;
}
.fc tfoot,
.fc thead th,
.fc tbody th div,
.fc tbody td.count,
.fc .cards tbody td a,
.fc td.percent var,
.fc .timestamp span {
  color: #000000;
}
.fc .indent .count {
  color: #4b4b4b;
}
.fc .cards tbody td a span {
  color: #7d7d7d;
}
/* ----- Chart Widget Hover Colors ----- */

.fc tbody tr:hover td,
.fc tbody tr:hover th,
.fc tfoot tr:hover td,
.fc tfoot tr:hover th {
  background-color: #FFF7C0;
}
.fc tbody tr:hover th div,
.fc tbody tr:hover td,
.fc tbody tr:hover var,
.fc tfoot tr:hover th div,
.fc tfoot tr:hover td,
.fc tfoot tr:hover var {
  color: #000000;
}
/* ----- Payment Summary ----- */

.invoice thead th,
.invoice tbody th,
.invoice tbody td,
.invoice tfoot th,
.invoice .total,
.invoice tfoot .last th,
.invoice tfoot .last td,
.invoice tfoot th,
.invoice tfoot td {
  border-color: #dedede;
}
.invoice thead th,
.wufoo .checkNotice {
  background: #f5f5f5;
}
.invoice th,
.invoice td {
  color: #000000;
}
#ppSection,
#ccSection {
  border-bottom: 1px dotted #CCCCCC;
}
#shipSection,
#invoiceSection {
  border-top: 1px dotted #CCCCCC;
}
/* Drop Shadows */
/* - - - Local Fonts - - - */
/* - - - Responsive - - - */

@media only screen and (max-width: 480px) {
  html {
    background-color: #FFFFFF;
  }
  a.powertiny b,
  a.powertin em {
    color: #1a1a1a !important;
  }
}
/* - - - Custom Theme - - - */
body,
.wufoo,
.wufoo label.desc,
.wufoo legend.desc,
.wufoo .info h2,
.wufoo .info div,
.wufoo input.text,
.wufoo textarea.textarea,
.wufoo input.file,
.wufoo li div,
.wufoo li span,
.wufoo li div label,
.wufoo li span label,
.likert caption,
.likert thead td,
.likert tbody th label,
.wufoo .section h3,
.wufoo .section div,
.paging-context {
  color: #333
}
#logo {
  background-color: #6f5499
}
.wufoo .info h2 {
  font-size: 180%
}
form li div label,
form li span label,
.likert caption,
.likert tbody th label,
.likert thead td {
  font-size: 100%
}
.wufoo .instruct small,
.paging-context table tbody tr td.t b,
.paging-context table tbody tr td.c var,
.wufoo .info div,
.wufoo .section div {
  font-size: 14px
}
.paging-context table tbody tr td.c var {
  height: 30px;
  width: 30px;
  border-radius: 20px;
  line-height: 30px
}
.wufoo label.desc,
.wufoo legend.desc,
.likert caption,
.wufoo .section h3 {
  line-height: 1.42857143;
  color: #333;
  font-weight: bold;
  font-size: 120%
}
.wufoo input.text,
.wufoo textarea.textarea,
.wufoo select.select,
form li.complex div span.full input {
  width: 80%;
  height: 36px;
  padding: 3px 9px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075)
}
form li.complex div span.left,
form li.complex div span.right {
  margin: 0;
  width: 100%
}
form li.complex div span.left input,
form li.complex div span.right input,
form li.complex div span.left select,
form li.complex div span.right select {
  width: 80%
}
.wufoo textarea.textarea {
  height: 10em;
  min-width: 100px
}
.wufoo input.text:focus,
.wufoo textarea.textarea:focus,
.wufoo select.select:focus {
  outline: 0;
  border-color: #bbb;
  box-shadow: 0 0 2px #c9c9c9
}
select.select {
  -webkit-appearance: menulist-button;
  background-color: #fff;
  box-sizing: content-box
}
.wufoo input.text.fn {
  margin-right: 3em
}
span.symbol {
  margin-left: 1em;
  margin-right: 0.1em;
  margin-top: 15px
}
.wufoo li.focused {
  background: none
}
#saveForm,
input.btTxt {
  cursor: pointer;
  border: 1px solid #3498db;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  box-shadow: none;
  color: #ffffff;
  background-color: #3498db
}
button.link {
  text-decoration: none;
  color: #A884DE
}
.safari label.choice {
  margin-top: 5px
}
.wufoo input.checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  background-color: white;
  border: 1px solid #c3c3c3;
  border-radius: 3px;
  width: 20px;
  height: 20px;
  margin-top: 5px;
  position: absolute
}
.wufoo input.checkbox:active,
input.checkbox:checked:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px 1px 3px rgba(0, 0, 0, 0.1)
}
.wufoo input.checkbox:checked {
  background-color: #f2f2f2;
  border: 1px solid #c3c3c3;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05), inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  color: #99a1a7
}
.wufoo input.checkbox:checked:after {
  content: '\2714';
  font-size: 14px;
  position: relative;
  top: 0px;
  left: 3px;
  color: #99a1a7
}
.wufoo input.radio {
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  background-color: white;
  border: 1px solid #c3c3c3;
  border-radius: 50px;
  padding: 9px;
  width: 20px;
  height: 20px;
  margin-top: 0;
  position: absolute
}
.wufoo input.radio:checked:after {
  content: ' ';
  background-color: #99a1a7;
  border-radius: 50px;
  width: 12px;
  height: 12px;
  border: 1px solid #c3c3c3;
  text-shadow: 0px;
  font-size: 20px;
  position: absolute;
  top: 3px;
  left: 3px
}
.wufoo input.radio:checked {
  background-color: #f2f2f2;
  color: #99a1a7;
  border: 1px solid #adb8c0
}
.wufoo label.choice {
  display: block;
  margin-left: 10px;
  padding-left: 20px
}
.wufoo .likert input {
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  background-color: white;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  width: 20px;
  height: 20px;
  margin-top: 3px;
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: #c3c3c3;
  border-radius: 50px;
  padding: 9px
}
.wufoo .likert input:checked {
  background-color: #f2f2f2;
  color: #99a1a7;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-width: 1px;
  border-style: solid;
  border-color: #adb8c0
}
.wufoo .likert input:checked:after {
  content: ' ';
  background-color: #99a1a7;
  border-radius: 50px;
  width: 12px;
  height: 12px;
  border: 1px solid #c3c3c3;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.3);
  text-shadow: 0px;
  font-size: 20px;
  position: absolute;
  top: 2px;
  left: 2px
}
.wufoo li.focused {
  border-radius: 5px;
  background: #E5F0FF
}
form li .datepicker {
  margin-left: 15px
}
form li.time select.select {
  margin-left: 15px
}
.wufoo input[type="file"]::-webkit-file-upload-button {
  cursor: pointer;
  border: 1px solid #3498db;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  border-radius: 4px;
  -webkit-user-select: none;
  box-shadow: none;
  color: #ffffff;
  background-color: #3498db
}
.wufoo input[type="file"]::-moz-file-upload-button {
  cursor: pointer;
  border: 1px solid #3498db;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  border-radius: 4px;
  -moz-user-select: none;
  box-shadow: none;
  color: #ffffff;
  background-color: #3498db
}
.rating span {
  margin-right: 10px
}

#saveForm {
  background: rgb(122, 100, 136);
  color: #fff;
  border: 1px solid;
  padding: 15px 30px;
  transition: 200ms all ease-out;
}
  #saveForm:focus {
    outline: none;
  }
  #saveForm:focus,
  #saveForm:hover {
    background-color: rgb(82, 60, 96);
  }
.helper-text {
  margin: 0 0 1em;
  font-size: 15px;
}
</style>
